import User from "./User";
import Topic from "./Topic";
import extractTextfromHtml from "../common/helpers/extractTextFromHtml";

export default class Comment {
  constructor(data = {}, topicSlug) {
    this.id = String(data.id);
    this.createdAt = data.created_at ? new Date(data.created_at) : new Date();
    this.canEdit = data.can_edit;
    this.canDelete = data.can_delete;
    this.slug = `${topicSlug}-${this.id}`;
    this.comment = extractTextfromHtml(data.cooked || "");
    this.htmlComment = data.cooked || "";
    this.topicSlug = topicSlug;

    this.user = new User({
      ...data,
      id: data.userId,
      screenName: data.username,
      fullName: data.name,
    });

    this.topic = new Topic({
      ...data,
      original_post_id: this.id,
      slug: this.slug,
      like_count: data.like_count,
    });
  }
}
